const HOURS = Array.from({ length: 24 }, (_, i) => i)

const cellBorder = 'border-b border-r border-gray-200 last:border-r-0'

// Generic hourly grid: rows = days of month, columns = hours 0–23.
// getCellStyle(value) → { bg, text } | null   — optional cell coloring
// formatCell(value)   → string                 — optional value formatter (default: toFixed(1))
// orientation: 'normal' (řádky = dny, sloupce = hodiny) | 'transposed' (řádky = hodiny, sloupce = dny)
export function HlyGrid({ year, month, days, dataMap, localToUtcMap, getCellStyle, formatCell, orientation = 'normal' }) {
  const fmt = formatCell ?? (v => v.toFixed(1))
  const transposed = orientation === 'transposed'
  const mm = String(month).padStart(2, '0')

  const valueAt = (day, hour) => {
    const dd = String(day).padStart(2, '0')
    const localKey = `${year}-${mm}-${dd} ${String(hour).padStart(2, '0')}`
    const utcKey = localToUtcMap ? localToUtcMap.get(localKey) : localKey
    return utcKey != null ? (dataMap.get(utcKey) ?? null) : null
  }

  return (
    <div className="h-full overflow-hidden border border-gray-200">
    <div className="h-full overflow-auto">
      <table className="border-separate border-spacing-0 border-l-2 border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs">
        <thead>
          <tr>
            <th className="sticky left-0 top-0 z-30 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-400 px-2 py-1 text-gray-500 font-normal min-w-[3rem]">
              {transposed ? 'Hod.' : 'Den'}
            </th>
            {transposed
              ? Array.from({ length: days }, (_, i) => i + 1).map(day => (
                  <th key={day} className={`sticky top-0 z-20 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 ${cellBorder} px-1 py-1 text-gray-500 font-normal text-center min-w-[2.6rem]`}>
                    {day}.
                  </th>
                ))
              : HOURS.map(h => (
                  <th key={h} className={`sticky top-0 z-20 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 ${cellBorder} px-1 py-1 text-gray-500 font-normal text-center min-w-[2.8rem]`}>
                    {String(h).padStart(2, '0')}
                  </th>
                ))}
          </tr>
        </thead>
        <tbody>
          {transposed
            ? HOURS.map(h => (
                <tr key={h} className="group">
                  <td className="sticky left-0 z-10 bg-gray-50 border-b border-r border-r-gray-400 border-gray-200 group-last:border-b-0 px-2 py-0.5 text-gray-500 text-center whitespace-nowrap">
                    {String(h).padStart(2, '0')}
                  </td>
                  {Array.from({ length: days }, (_, i) => i + 1).map(day => {
                    const value = valueAt(day, h)
                    const style = getCellStyle ? getCellStyle(value) : null
                    return (
                      <td
                        key={day}
                        style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                        className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap ${!style ? 'text-gray-300' : ''}`}
                      >
                        {value != null ? fmt(value) : '—'}
                      </td>
                    )
                  })}
                </tr>
              ))
            : Array.from({ length: days }, (_, i) => {
                const day = i + 1
                return (
                  <tr key={day} className="group">
                    <td className="sticky left-0 z-10 bg-gray-50 border-b border-r border-r-gray-400 border-gray-200 group-last:border-b-0 px-2 py-0.5 text-gray-500 text-center whitespace-nowrap">
                      {day}.
                    </td>
                    {HOURS.map(h => {
                      const value = valueAt(day, h)
                      const style = getCellStyle ? getCellStyle(value) : null
                      return (
                        <td
                          key={h}
                          style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                          className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap ${!style ? 'text-gray-300' : ''}`}
                        >
                          {value != null ? fmt(value) : '—'}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
        </tbody>
      </table>
    </div>
    </div>
  )
}
